import FileSaver from 'file-saver'

export const exportToCsv = ({ CsvString, title, extension }: { CsvString: any, title?: string, extension?: string }): void => {

  const blobFile = new Blob(CsvString, { type: 'fileFormat' });
  FileSaver.saveAs(blobFile, `${title ?? 'report'}.${extension ?? 'csv'}`);
};
